module.exports = __webpack_public_path__ + "img/Rectangle 2627.baf9c276.svg";